<template>
  <div id="BMCampaigns">
    <v-container class="pa-0">
      <v-layout>
      <v-flex class="xs12 sm12 mb-5">
        <v-btn v-if="true" fab absolute right class="mr-3 pf-btn-fab" @click="showAddCampaignPopup = true">
          <v-icon>add</v-icon>
        </v-btn>
      </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-md fluid class="pt-0">
      <v-card-title>
        <v-select v-model="searchByCampaignStatus" label="Search by campaign status" :items="statusList" class="pr-2" @change="filterByStatus"></v-select>
        <v-select v-model="searchByAdStatus" label="Search by ad status" :items="statusList" class="pr-2" @change="filterByStatus"></v-select>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <!-- <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          ></v-text-field> -->
      </v-card-title>
      <v-card class="mt-1">
        <v-data-table
          :headers="headers"
          :items="googleAdList"
          class="pf-data-table" 
          :pagination.sync="pagination"
          >
          <template v-slot:items="props">
            <td>{{ props.item.campaign.name }}</td>
            <td>{{ props.item.campaign.type }}</td>
            <td>{{ props.item.account && props.item.account.nickname ? props.item.account.nickname : '--' }}</td>
            <td>{{ props.item.campaign.budget }}</td>
            <td>{{ formatDate(props.item.campaign.start_date, 'MM/DD/YYYY') }}</td>
            <td>{{ props.item.campaign.status }}/{{ props.item.status }}</td>
            <td>Completed</td>
            <td width="130" align="right">
              <v-btn icon class="ma-0" @click="adAdditionalInfo(props.item)" title="Publish Campaign" :disabled="props.item.status !== 'PENDING' && props.item.campaign.status !== 'PENDING'">
                <v-icon size="22" color="grey darken-2">campaign</v-icon>
              </v-btn>
              <v-btn icon class="ma-0" @click="editAdTexts(props.item)" title="Edit Texts" :disabled="props.item.status === 'PENDING' || props.item.campaign.status === 'PENDING'">
                <v-icon size="22" color="grey darken-2">edit</v-icon>
              </v-btn>
              <v-btn icon class="ma-0" @click="deleteItem(props.item)" disabled>
                <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <app-modal :active="showAddDetailsPopup" v-if="showAddDetailsPopup" width="75%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="resetSelections()">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Ad additional info</v-toolbar-title>
          </v-toolbar>
          <v-card-title>
            <v-layout class="pr-4 pl-4 button-container">
              <v-flex xs12 sm12 md12 class="pr-0 text-xs-right">
                <div class="d-inline-flex">
                  <v-btn class="pf-btn pf-btn-save" @click="saveAdTexts" :disabled="saveDaftDisabled">
                    <v-icon size="16" class="pr-1">check_circle</v-icon>
                    <div>Save Draft</div>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="mb-4">
            <v-form ref="adInfoForm">

              <v-layout wrap class="mb-2">
                <v-flex sm6>
                  <v-select
                    v-model="adType"
                    :rules="rules.location"
                    label="Ad Type"
                    :items="adTypes"
                    item-text="text"
                    item-value="name"
                    @change="adTypeChanged()"
                    class="required pr-4 pl-4">
                  </v-select>
                </v-flex>
                <!-- <v-flex sm6>
                  <v-select
                    v-model="bidStrategy"
                    :rules="rules.location"
                    label="Bidding Strategy"
                    :items="bidStrategies"
                    item-text="text"
                    item-value="name"
                    @change="isAdTextsChanged = true"
                    class="required pr-4 pl-4">
                  </v-select>
                </v-flex> -->
              </v-layout>

              <h4 class="ml-3 mt-2"><b>Ad Texts</b></h4>
              <h3 class="ml-3 mt-3 pf-sub-head">Ad Headlines <small>(Min {{ textCountLimits[adType].headlines.min }}, Max {{ textCountLimits[adType].headlines.max }} Nos)</small></h3>
              <v-layout wrap v-for="(headline, i) in currentAdTexts.headlines" :key="i" class="mb-2">
                <v-flex sm6 xs10>
                  <v-text-field v-model.number="currentAdTexts.headlines[i]" :rules="rules.headline" :label="`Ad headline ${i + 1}`" @input="isAdTextsChanged = true" class="required pr-4 pl-4" counter="30"></v-text-field>
                </v-flex>
                <v-flex sm6 xs2>
                  <v-btn
                    v-if="i === currentAdTexts.headlines.length - 1 && i >= textCountLimits[adType].headlines.min - 1 && currentAdTexts.headlines.length < textCountLimits[adType].headlines.max"
                    class="pf-btn-text-white pf-bg-green"
                    @click="addAdText('headlines')"
                    :disabled="!!(currentAdTexts.headlines.filter(x => x === '' || x.length > 30).length)"
                  >
                    Add More
                  </v-btn>
                  <v-btn
                    v-if="i > textCountLimits[adType].headlines.min - 1"
                    class="pf-btn-text-white pf-bg-pink"
                    @click="removeAdText('headlines', i)"
                  >
                    Remove
                  </v-btn>
                </v-flex>
              </v-layout>

              <template v-if="isAdLongHeadActive">
                <h3 class="ml-3 mt-3 pf-sub-head">Ad Long Headline</h3>
                <v-layout wrap class="mb-2">
                  <v-flex sm6 xs10>
                    <v-textarea v-model.number="currentAdTexts.long_headline" :rules="rules.long_headline" label="Ad long headline" rows="2" @input="isAdTextsChanged = true" class="required pr-4 pl-4" counter="90"></v-textarea>
                  </v-flex>
                </v-layout>
              </template>

              <h3 class="ml-3 mt-3 pf-sub-head">Ad Descriptions <small>(Min {{ textCountLimits[adType].descriptions.min }}, Max {{ textCountLimits[adType].descriptions.max }} Nos)</small></h3>
              <v-layout wrap v-for="(description, i) in currentAdTexts.descriptions" :key="i + textCountLimits[adType].descriptions.max" class="mb-2">
                <v-flex sm6 xs10>
                  <v-textarea v-model.number="currentAdTexts.descriptions[i]" :rules="rules.description" :label="`Ad description ${i + 1}`" @input="isAdTextsChanged = true" rows="2" class="required pr-4 pl-4" counter="90"></v-textarea>
                </v-flex>
                <v-flex sm6 xs2>
                  <v-btn
                    v-if="i === currentAdTexts.descriptions.length - 1 && i >= textCountLimits[adType].descriptions.min - 1 && currentAdTexts.descriptions.length < textCountLimits[adType].descriptions.max"
                    class="pf-btn-text-white pf-bg-green"
                    @click="addAdText('descriptions')"
                    :disabled="!!(currentAdTexts.descriptions.filter(x => x === '' || x.length > 90).length)"
                  >
                    Add More
                  </v-btn>
                  <v-btn
                    v-if="i > textCountLimits[adType].descriptions.min - 1"
                    class="pf-btn-text-white pf-bg-pink"
                    @click="removeAdText('descriptions', i)"
                  >
                    Remove
                  </v-btn>
                </v-flex>
              </v-layout>

              <template v-if="isAdBusinessNameActive">
                <v-layout wrap>
                  <v-flex sm6>
                    <v-text-field v-model.number="currentAdTexts.business_name" :rules="rules.business_name" label="Ad business name" @input="isAdTextsChanged = true" class="required pr-4 pl-4"></v-text-field>
                  </v-flex>
                </v-layout>
              </template>

              <template v-if="isAdImageAssetsActive">
                <v-layout wrap>
                  <v-flex sm6 class="mt-4 flex-start pr-4 pl-4">
                    <upload-btn ref="landscape" @file-update="fileSelected($event, 'landscape')" title="Ad landscape image" noTitleUpdate>
                      <template slot="icon-left">
                        <v-icon size="16" class="pr-1">upload</v-icon>
                      </template>
                    </upload-btn>
                    <v-icon size="35" :color="!!currentAssets.landscape ? 'green' : 'red'">{{ !!currentAssets.landscape ? 'check_circle' : 'cancel' }}</v-icon>
                  </v-flex>
                  <v-flex sm6 class="mt-4 flex-start pr-4 pl-4">
                    <upload-btn @file-update="fileSelected($event, 'square')" ref="square" title="Ad square image" noTitleUpdate>
                      <template slot="icon-left">
                        <v-icon size="16" class="pr-1">upload</v-icon>
                      </template>
                    </upload-btn>
                    <v-icon size="35" :color="!!currentAssets.square ? 'green' : 'red'">{{ !!currentAssets.square ? 'check_circle' : 'cancel' }}</v-icon>
                  </v-flex>
                  <v-flex sm6 class="mt-4 flex-column pr-4 pl-4">
                    <h4 class="mb-2">Minimum image resolutions</h4>
                    <span><b>Landscape: </b>{{ assetResolution.landscape.width }} x {{ assetResolution.landscape.height }}</span>
                    <span><b>Square: </b>{{ assetResolution.square.width }} x {{ assetResolution.square.height }}</span>
                    <small>Images should have the minimum resolutions.</small>
                  </v-flex>
                </v-layout>
              </template>

              <template v-if="isAdVideoAssetsActive">
                <h3 class="ml-3 mt-4 pf-sub-head">Ad Youtube Video <small>(optional)</small></h3>
                <v-layout wrap>
                  <v-flex sm6 xs12>
                    <v-text-field v-model="currentAssets.youtubeVideo.title" label="Video title (optional)" @input="isAdTextsChanged = true" class="pr-4 pl-4"></v-text-field>
                    <v-text-field v-model="currentAssets.youtubeVideo.videoId" label="Video ID (ex: wtIMTCHWuIs)" @input="isAdTextsChanged = true" class="pr-4 pl-4" hint="https://www.youtube.com/watch?v=XXXXXXXXXXX, XXXXXXXXXXX is the Id" persistent-hint></v-text-field>
                  </v-flex>
                </v-layout>
              </template>

            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                class="pf-btn-text-white pf-bg-green"
                @click="publishCampaign"
                :disabled="isPublishButtonDisabled"
              >
                Publish Campaign
              </v-btn>
            <v-btn
              class="pf-btn-text-white pf-bg-pink"
              @click="resetSelections()"
              >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal>
    <app-modal :active="showEditTextsPopup" v-if="showEditTextsPopup" width="70%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="resetSelections(true)">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Update ad texts</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="mt-3 mb-4">
            <v-form ref="adTextsUpdateForm">
              <h4 class="ml-3 mt-2"><b>Ad Texts</b></h4>
              <h3 class="ml-3 mt-3 pf-sub-head">Ad Headlines <small>(Min {{ textCountLimits[adType].headlines.min }}, Max {{ textCountLimits[adType].headlines.max }} Nos)</small></h3>
              <v-layout wrap v-for="(headline, i) in currentAdTexts.headlines" :key="i + textCountLimits[adType].headlines.max" class="mb-2">
                <v-flex sm6 xs10>
                  <v-text-field v-model.number="currentAdTexts.headlines[i]" :rules="rules.headline" :label="`Ad headline ${i + 1}`" @input="isAdTextsChanged = true" class="required pr-4 pl-4" counter="30"></v-text-field>
                </v-flex>
                <v-flex sm6 xs2>
                  <v-btn
                    v-if="i === currentAdTexts.headlines.length - 1 && i >= textCountLimits[adType].headlines.min - 1 && currentAdTexts.headlines.length < textCountLimits[adType].headlines.max"
                    class="pf-btn-text-white pf-bg-green"
                    @click="addAdText('headlines')"
                    :disabled="!!(currentAdTexts.headlines.filter(x => x === '' || x.length > 30).length)"
                  >
                    Add More
                  </v-btn>
                  <v-btn
                    v-if="i > textCountLimits[adType].headlines.min - 1"
                    class="pf-btn-text-white pf-bg-pink"
                    @click="removeAdText('headlines', i)"
                  >
                    Remove
                  </v-btn>
                </v-flex>
              </v-layout>

              <template v-if="isAdLongHeadActive">
                <h3 class="ml-3 mt-3 pf-sub-head">Ad Long Headline</h3>
                <v-layout wrap class="mb-2">
                  <v-flex sm6 xs10>
                    <v-textarea v-model.number="currentAdTexts.long_headline" :rules="rules.long_headline" label="Ad long headline" rows="2" @input="isAdTextsChanged = true" class="required pr-4 pl-4" counter="90"></v-textarea>
                  </v-flex>
                </v-layout>
              </template>

              <h3 class="ml-3 mt-3 pf-sub-head">Ad Descriptions <small>(Min {{ textCountLimits[adType].descriptions.min }}, Max {{ textCountLimits[adType].descriptions.max }} Nos)</small></h3>
              <v-layout wrap v-for="(description, i) in currentAdTexts.descriptions" :key="i + textCountLimits[adType].descriptions.max" class="mb-2">
                <v-flex sm6 xs10>
                  <v-textarea v-model.number="currentAdTexts.descriptions[i]" :rules="rules.description" :label="`Ad description ${i + 1}`" @input="isAdTextsChanged = true" rows="2" class="required pr-4 pl-4" counter="90"></v-textarea>
                </v-flex>
                <v-flex sm6 xs2>
                  <v-btn
                    v-if="i === currentAdTexts.descriptions.length - 1 && i >= textCountLimits[adType].descriptions.min - 1 && currentAdTexts.descriptions.length < textCountLimits[adType].descriptions.max"
                    class="pf-btn-text-white pf-bg-green"
                    @click="addAdText('descriptions')"
                    :disabled="!!(currentAdTexts.descriptions.filter(x => x === '' || x.length > 90).length)"
                  >
                    Add More
                  </v-btn>
                  <v-btn
                    v-if="i > textCountLimits[adType].descriptions.min - 1"
                    class="pf-btn-text-white pf-bg-pink"
                    @click="removeAdText('descriptions', i)"
                  >
                    Remove
                  </v-btn>
                </v-flex>
              </v-layout>

              <template v-if="isAdBusinessNameActive">
                <v-layout wrap>
                  <v-flex sm6>
                    <v-text-field v-model.number="currentAdTexts.business_name" :rules="rules.business_name" label="Ad business name" @input="isAdTextsChanged = true" class="required pr-4 pl-4"></v-text-field>
                  </v-flex>
                </v-layout>
              </template>
              <!-- <v-layout wrap>
                <v-flex sm6 class="mt-4 flex-start pr-4 pl-4">
                  <upload-btn ref="landscape" @file-update="fileSelected($event, 'landscape')" title="Ad landscape image" noTitleUpdate>
                    <template slot="icon-left">
                      <v-icon size="16" class="pr-1">upload</v-icon>
                    </template>
                  </upload-btn>
                  <v-icon size="35" :color="!!currentAssets.landscape ? 'green' : 'red'">{{ !!currentAssets.landscape ? 'check_circle' : 'cancel' }}</v-icon>
                </v-flex>
                <v-flex sm6 class="mt-4 flex-start pr-4 pl-4">
                  <upload-btn @file-update="fileSelected($event, 'square')" ref="square" title="Ad square image" noTitleUpdate>
                    <template slot="icon-left">
                      <v-icon size="16" class="pr-1">upload</v-icon>
                    </template>
                  </upload-btn>
                  <v-icon size="35" :color="!!currentAssets.square ? 'green' : 'red'">{{ !!currentAssets.square ? 'check_circle' : 'cancel' }}</v-icon>
                </v-flex>
                <v-flex sm6 class="mt-4 flex-column pr-4 pl-4">
                  <h4 class="mb-2">Minimum image resolutions</h4>
                  <span><b>Landscape: </b>{{ assetResolution.landscape.width }} x {{ assetResolution.landscape.height }}</span>
                  <span><b>Square: </b>{{ assetResolution.square.width }} x {{ assetResolution.square.height }}</span>
                  <small>Images should have the minimum resolutions.</small>
                </v-flex>
              </v-layout> -->
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                class="pf-btn-text-white pf-bg-green"
                @click="publishAdTexts"
                :disabled="!isAdTextsChanged"
              >
                Publish Update
              </v-btn>
            <v-btn
              class="pf-btn-text-white pf-bg-pink"
              @click="resetSelections(true)"
              >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal>
    <app-modal :active="showCropImagePopup" v-if="showCropImagePopup && croppingImage" width="80%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="closeImageCrop">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Crop the image</v-toolbar-title>
          </v-toolbar>
          <v-layout wrap class="mt-4 mb-4 flex-center">
              <cropper
                v-if="!croppedImage"
                class="cropper"
                ref="cropper"
                :src="croppingImage"
                :stencil-props="{
                  aspectRatio: assetRatio[croppingImageType].width / assetRatio[croppingImageType].height,
                }"
                check-orientation
                :min-width="assetResolution[croppingImageType].width"
                :min-height="assetResolution[croppingImageType].height"
                :size-restrictions-algorithm="cropImageRestriction"
              ></cropper>
              <v-flex v-else class="flex-center">
                <img :src="croppedImage" class="crop-preview-image" />
              </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                v-if="croppedImage"
                class="pf-btn-text-white pf-bg-teal"
                @click="croppedImage = null"
                :disabled="false"
              >
                Back
              </v-btn>
              <v-btn
                v-if="!croppedImage"
                class="pf-btn-text-white pf-bg-green"
                @click="cropImage"
                :disabled="false"
              >
                Crop Image
              </v-btn>
              <v-btn
                v-else
                class="pf-btn-text-white pf-bg-green"
                @click="saveCroppedImage"
                :disabled="false"
              >
                Save
              </v-btn>
              <v-btn
                class="pf-btn-text-white pf-bg-pink"
                @click="closeImageCrop"
                >
                Close
              </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal>

    <app-modal :active="showAddCampaignPopup" v-if="showAddCampaignPopup" width="70%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="resetSelections()">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Add campaign</v-toolbar-title>
          </v-toolbar>
          <!-- <v-card-title>
            <v-layout class="pr-4 pl-4 button-container">
              <v-flex xs12 sm12 md12 class="pr-0 text-xs-right">
                <div class="d-inline-flex">
                  <v-btn class="pf-btn pf-btn-save" @click="saveAdTexts" :disabled="saveDaftDisabled">
                    <v-icon size="16" class="pr-1">check_circle</v-icon>
                    <div>Save Draft</div>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card-title> -->
          <v-card-text class="mb-4">
            <v-form ref="newAdInfoForm">

              <v-layout wrap class="mb-2">
                <v-flex sm6>
                  <v-select
                    v-model="newAdFamily"
                    :rules="rules.location"
                    label="Family"
                    :items="getFamilyList"
                    item-text="name"
                    item-value="id"
                    @change="newAdFamilyChanged()"
                    class="required pr-4 pl-4">
                  </v-select>
                </v-flex>
              </v-layout>

              <template v-if="isNewAdFamilySelected">
                <v-layout wrap class="mb-2">
                  <v-flex sm6>
                    <v-select
                      v-model="adType"
                      :rules="rules.location"
                      label="Ad Type"
                      :items="adTypes"
                      item-text="text"
                      item-value="name"
                      disabled
                      @change="adTypeChanged()"
                      class="required pr-4 pl-4">
                    </v-select>
                  </v-flex>
                </v-layout>
                <v-layout wrap class="mb-2">
                  <v-flex sm6>
                    <v-text-field v-model.number="newCampaignBudget" :rules="rules.budget" :label="`New Campaign Budget (Max: $ ${remainingBudget.toFixed(2)})`" class="required pr-4 pl-4" @input="isAdTextsChanged = true" @blur="validateNewBudget" prepend-inner-icon="attach_money"></v-text-field>
                  </v-flex>
                </v-layout>

                <h4 class="ml-3 mt-2"><b>Ad Texts</b></h4>
                <h3 class="ml-3 mt-3 pf-sub-head">Ad Headlines <small>(Min {{ textCountLimits[adType].headlines.min }}, Max {{ textCountLimits[adType].headlines.max }} Nos)</small></h3>
                <v-layout wrap v-for="(headline, i) in currentAdTexts.headlines" :key="i" class="mb-2">
                  <v-flex sm6 xs10>
                    <v-text-field v-model.number="currentAdTexts.headlines[i]" :rules="rules.headline" :label="`Ad headline ${i + 1}`" @input="isAdTextsChanged = true" class="required pr-4 pl-4" counter="30"></v-text-field>
                  </v-flex>
                  <v-flex sm6 xs2>
                    <v-btn
                      v-if="i === currentAdTexts.headlines.length - 1 && i >= textCountLimits[adType].headlines.min - 1 && currentAdTexts.headlines.length < textCountLimits[adType].headlines.max"
                      class="pf-btn-text-white pf-bg-green"
                      @click="addAdText('headlines')"
                      :disabled="!!(currentAdTexts.headlines.filter(x => x === '' || x.length > 30).length)"
                    >
                      Add More
                    </v-btn>
                    <v-btn
                      v-if="i > textCountLimits[adType].headlines.min - 1"
                      class="pf-btn-text-white pf-bg-pink"
                      @click="removeAdText('headlines', i)"
                    >
                      Remove
                    </v-btn>
                  </v-flex>
                </v-layout>

                <template v-if="isAdLongHeadActive">
                  <h3 class="ml-3 mt-3 pf-sub-head">Ad Long Headline</h3>
                  <v-layout wrap class="mb-2">
                    <v-flex sm6 xs10>
                      <v-textarea v-model.number="currentAdTexts.long_headline" :rules="rules.long_headline" label="Ad long headline" rows="2" @input="isAdTextsChanged = true" class="required pr-4 pl-4" counter="90"></v-textarea>
                    </v-flex>
                  </v-layout>
                </template>

                <h3 class="ml-3 mt-3 pf-sub-head">Ad Descriptions <small>(Min {{ textCountLimits[adType].descriptions.min }}, Max {{ textCountLimits[adType].descriptions.max }} Nos)</small></h3>
                <v-layout wrap v-for="(description, i) in currentAdTexts.descriptions" :key="i + textCountLimits[adType].descriptions.max" class="mb-2">
                  <v-flex sm6 xs10>
                    <v-textarea v-model.number="currentAdTexts.descriptions[i]" :rules="rules.description" :label="`Ad description ${i + 1}`" @input="isAdTextsChanged = true" rows="2" class="required pr-4 pl-4" counter="90"></v-textarea>
                  </v-flex>
                  <v-flex sm6 xs2>
                    <v-btn
                      v-if="i === currentAdTexts.descriptions.length - 1 && i >= textCountLimits[adType].descriptions.min - 1 && currentAdTexts.descriptions.length < textCountLimits[adType].descriptions.max"
                      class="pf-btn-text-white pf-bg-green"
                      @click="addAdText('descriptions')"
                      :disabled="!!(currentAdTexts.descriptions.filter(x => x === '' || x.length > 90).length)"
                    >
                      Add More
                    </v-btn>
                    <v-btn
                      v-if="i > textCountLimits[adType].descriptions.min - 1"
                      class="pf-btn-text-white pf-bg-pink"
                      @click="removeAdText('descriptions', i)"
                    >
                      Remove
                    </v-btn>
                  </v-flex>
                </v-layout>

                <template v-if="isAdBusinessNameActive">
                  <v-layout wrap>
                    <v-flex sm6>
                      <v-text-field v-model.number="currentAdTexts.business_name" :rules="rules.business_name" label="Ad business name" @input="isAdTextsChanged = true" class="required pr-4 pl-4"></v-text-field>
                    </v-flex>
                  </v-layout>
                </template>

                <template v-if="isAdImageAssetsActive">
                  <v-layout wrap>
                    <v-flex sm6 class="mt-4 flex-start pr-4 pl-4">
                      <upload-btn ref="landscape" @file-update="fileSelected($event, 'landscape')" title="Ad landscape image" noTitleUpdate>
                        <template slot="icon-left">
                          <v-icon size="16" class="pr-1">upload</v-icon>
                        </template>
                      </upload-btn>
                      <v-icon size="35" :color="!!currentAssets.landscape ? 'green' : 'red'">{{ !!currentAssets.landscape ? 'check_circle' : 'cancel' }}</v-icon>
                    </v-flex>
                    <v-flex sm6 class="mt-4 flex-start pr-4 pl-4">
                      <upload-btn @file-update="fileSelected($event, 'square')" ref="square" title="Ad square image" noTitleUpdate>
                        <template slot="icon-left">
                          <v-icon size="16" class="pr-1">upload</v-icon>
                        </template>
                      </upload-btn>
                      <v-icon size="35" :color="!!currentAssets.square ? 'green' : 'red'">{{ !!currentAssets.square ? 'check_circle' : 'cancel' }}</v-icon>
                    </v-flex>
                    <v-flex sm6 class="mt-4 flex-column pr-4 pl-4">
                      <h4 class="mb-2">Minimum image resolutions</h4>
                      <span><b>Landscape: </b>{{ assetResolution.landscape.width }} x {{ assetResolution.landscape.height }}</span>
                      <span><b>Square: </b>{{ assetResolution.square.width }} x {{ assetResolution.square.height }}</span>
                      <small>Images should have the minimum resolutions.</small>
                    </v-flex>
                  </v-layout>
                </template>

                <template v-if="isAdVideoAssetsActive">
                  <h3 class="ml-3 mt-4 pf-sub-head">Ad Youtube Video <small>(optional)</small></h3>
                  <v-layout wrap>
                    <v-flex sm6 xs12>
                      <v-text-field v-model="currentAssets.youtubeVideo.title" label="Video title (optional)" @input="isAdTextsChanged = true" class="pr-4 pl-4"></v-text-field>
                      <v-text-field v-model="currentAssets.youtubeVideo.videoId" label="Video ID (ex: wtIMTCHWuIs)" @input="isAdTextsChanged = true" class="pr-4 pl-4" hint="https://www.youtube.com/watch?v=XXXXXXXXXXX, XXXXXXXXXXX is the Id" persistent-hint></v-text-field>
                    </v-flex>
                  </v-layout>
                </template>
              </template>

            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                class="pf-btn-text-white pf-bg-green"
                @click="publishDirectCampaign"
                :disabled="isPublishButtonDisabled"
              >
                Publish Campaign
              </v-btn>
            <v-btn
              class="pf-btn-text-white pf-bg-pink"
              @click="resetSelections()"
              >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal>
  </div>
</template>
<script>
/* global session store config */
/* eslint-disable indent */
import AppModal from '../../components/AppModal';
import { getCollection, uploadFile, request, formatDate, create, update } from '../../helpers/helpers';

import UploadButton from 'vuetify-upload-button';
import swal from 'sweetalert2';

import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

import { mapGetters } from 'vuex';

export default {
  name: 'BMCampaigns',
  components: {
    'app-modal': AppModal,
    'upload-btn': UploadButton,
    Cropper
  },
  data: (vm) => ({
    headers: [
      { text: 'Campaign', value: 'campaign.name', align: 'left' },
      { text: 'Type', value: 'type', align: 'left' },
      { text: 'Nickname', value: 'account.nickname', align: 'left' },
      { text: 'Budget', value: 'budget', align: 'left' },
      { text: 'Start Date', value: 'start_date', align: 'left' },
      { text: 'Campaign/Ad', value: 'campaign.status', align: 'left' },
      { text: 'Payment', value: 'payment_status', align: 'left' },
      { text: '', sortable: false }
    ],
    // search: '',
    pagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    },
    isAdTextsChanged: false,
    isNewAdFamilySelected: false,
    showAddCampaignPopup: false,
    newAdFamily: null,
    newCampaignBudget: 0,
    remainingBudget: 0,
    showAddDetailsPopup: false,
    showEditTextsPopup: false,
    showCropImagePopup: false,
    croppingImage: null,
    croppedImage: null,
    croppedCoords: null,
    croppingImageType: 'landscape',
    currentGoogleAd: null,
    currentAssets: {
      landscape: null,
      square: null,
      youtubeVideo: {
        title: '',
        videoId: ''
      }
    },
    newAdAssetIds: {
      landscape: null,
      square: null
    },
    isAdHeadActive: true,
    isAdLongHeadActive: true,
    isAdDescriptionActive: true,
    isAdImageAssetsActive: true,
    isAdVideoAssetsActive: true,
    isAdBusinessNameActive: true,
    currentAdTypes: ['RESPONSIVE_DISPLAY_AD', 'RESPONSIVE_SEARCH_AD'],
    adType: 'RESPONSIVE_DISPLAY_AD',
    adTypes: [
      { name: 'RESPONSIVE_DISPLAY_AD', text: 'Responsive display ad' },
      { name: 'RESPONSIVE_SEARCH_AD', text: 'Responsive search ad' }
    ],
    textCountLimits: {
      RESPONSIVE_DISPLAY_AD: {
        headlines: {
          min: 1,
          max: 5
        },
        descriptions: {
          min: 1,
          max: 5
        }
      },
      RESPONSIVE_SEARCH_AD: {
        headlines: {
          min: 3,
          max: 15
        },
        descriptions: {
          min: 2,
          max: 4
        }
      }
    },
    // bidStrategy: '',
    // bidStrategies: [
    //   // { name: 'RESPONSIVE_DISPLAY_AD', text: 'Responsive display ad' },
    //   // { name: 'RESPONSIVE_SEARCH_AD', text: 'Responsive search ad' }
    // ],
    currentAdTexts: {
      headlines: [''],
      descriptions: [''],
      long_headline: '',
      business_name: 'ParentFinder BM Campaign',
    },
    rules: {
      headline: [
        v => !!v || 'Ad headline is required',
        v => v.length <= 30 || 'Maximum allowed character count is 30'
      ],
      long_headline: [
        v => !!v || 'Ad long headline is required',
        v => v.length <= 90 || 'Maximum allowed character count is 90'
      ],
      description: [
        v => !!v || 'Ad description is required',
        v => v.length <= 90 || 'Maximum allowed character count is 90'
      ],
      business_name: [v => !!v || 'Ad business name is required'],
      budget: [
        v => !!v || 'Budget is required',
        // v => Number.isInteger(v) || 'Please enter an integer',
        // v => !vm.validateNewBudget() || `New campaign budget should not exceed the remaining budget, ${vm.remainingBudget.toFixed(2)} remains`
      ]
    },
    assetResolution: {
      landscape: {
        width: 600,
        height: 314
      },
      square: {
        width: 300,
        height: 300
      }
    },
    assetRatio: {
      landscape: {
        width: 1.91,
        height: 1
      },
      square: {
        width: 1,
        height: 1
      }
    },
    searchByCampaignStatus: 'ALL',
    searchByAdStatus: 'PENDING',
    statusList: ['ALL', 'PENDING', 'ENABLED', 'PAUSED', 'REMOVED'],
    googleAdList: []
  }),
  computed: {
    ...mapGetters(['Agency']),
    GoogleAd: {
      get () {
        return store.state.GoogleAd;
      },
      set (val) {
        store.commit('setGoogleAd', val);
      }
    },
    saveDaftDisabled () {
      switch (this.adType) {
        case 'RESPONSIVE_DISPLAY_AD':
          return !this.isAdTextsChanged || !this.currentAdTexts.headlines.filter(x => x.trim()).length || !this.currentAdTexts.long_headline.length || !this.currentAdTexts.descriptions.filter(x => x.trim()).length || !this.currentAdTexts.business_name.length;

        case 'RESPONSIVE_SEARCH_AD':
          return !this.isAdTextsChanged || !this.currentAdTexts.headlines.filter(x => x.trim()).length || !this.currentAdTexts.descriptions.filter(x => x.trim()).length || !this.currentAdTexts.business_name.length;

        default:
          return false;
      }
    },
    isPublishButtonDisabled () {
      switch (this.adType) {
        case 'RESPONSIVE_DISPLAY_AD':
          return this.saveDaftDisabled || !this.currentAssets.landscape || !this.currentAssets.square;

        case 'RESPONSIVE_SEARCH_AD':
          return this.saveDaftDisabled;

        default:
          return false;
      }
    },
    getFamilyList () {
      /* Get the families whose any one campaign got enabled */
      return this.GoogleAd.filter(x => x.status === 'ENABLED').map(x => {
        return { id: x.account.id, name: x.account.name };
      });
    }
  },
  watch: {
    GoogleAd (val) {
      this.googleAdList = JSON.parse(JSON.stringify(this.GoogleAd));
    }
  },
  async created () {
    await this.fetchGoogleAds();
    this.googleAdList = JSON.parse(JSON.stringify(this.GoogleAd));
    this.filterByStatus();
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    async init () {
      await this.fetchGoogleAds();
      this.googleAdList = JSON.parse(JSON.stringify(this.GoogleAd));
      this.filterByStatus();
    },
    formatDate (date, format) {
      return formatDate(date, format);
    },
    filterByStatus () {
      this.googleAdList = this.GoogleAd.filter(x => (this.searchByAdStatus === 'ALL' || x.status === this.searchByAdStatus) && (this.searchByCampaignStatus === 'ALL' || x.campaign.status === this.searchByCampaignStatus));
    },
    async getRemainingBudget () {
      if (this.newAdFamily) {
        let adIndex = this.GoogleAd.findIndex(x => x.account.id === this.newAdFamily);
        let exisitngCampaign = this.GoogleAd[adIndex].campaign;
        if (exisitngCampaign && exisitngCampaign.id) {
          let { error, data } = await request(`Campaign/BalanceBudget/${exisitngCampaign.id}`, 'GET');
          if (error) {
            this.snackbar = {
              show: true,
              color: 'red',
              text: error
            };
            console.log(error);
          } else {
            if (data && typeof data.remainingBudget !== 'undefined') {
              this.remainingBudget = data.remainingBudget || 0;
            }
          }
        }
      }
    },
    validateNewBudget () {
      if (this.newCampaignBudget && this.newCampaignBudget > this.remainingBudget) {
        swal.fire({
          type: 'warning',
          title: 'Budget Exceeded',
          text: `New campaign budget should not exceed the remaining budget, ${this.remainingBudget} remains`,
          showConfirmButton: true,
          onClose: () => {
            this.newCampaignBudget = 0;
          }
        });
        return;
      }
    },
    async newAdFamilyChanged () {
      /* Set false first */
      this.isNewAdFamilySelected = false;
      /* Set the adType */
      /* Find the existing ad type */
      /* Check if account don't have two ads already */
      /* Considering family will have only two campaign maximum */
      if (this.GoogleAd.filter(x => x.account.id === this.newAdFamily).length < this.currentAdTypes.length) {
        let adIndex = this.GoogleAd.findIndex(x => x.account.id === this.newAdFamily);
        if (adIndex > -1) {
          /* Populate the ad texts */
          if (this.GoogleAd[adIndex].texts && Object.keys(this.GoogleAd[adIndex].texts).length) {
            this.currentAdTexts = this.GoogleAd[adIndex].texts;
          }

          /* Find the type index */
          if (this.GoogleAd[adIndex].type === this.currentAdTypes[0]) {
            this.adType = this.currentAdTypes[1];
          } else {
            this.adType = this.currentAdTypes[0];
          }
          this.adTypeChanged();

          /* Reset the text counts */
          this.resetTextsCounts();

          /* Fetch the balance budget */
          await this.getRemainingBudget();

          /* Fetch the ad assets */
          let where = { account: this.newAdFamily, google_ad: this.GoogleAd[adIndex].id };
          let { error, data } = await getCollection('GoogleAdAsset', true, 0, '', where);
          if (error) {
            console.log(error);
          } else if (data && data.length) {
            /* Check if the asset is landscape or square */
            for (let i = 0; i < data.length; i++) {
              this.currentAssets[data[i].image_type] = data[i].resource;
              this.newAdAssetIds[data[i].image_type] = data[i].id;
            }
          }
          this.isNewAdFamilySelected = true;
        }
      } else {
        swal.fire({
          type: 'warning',
          title: 'Limit Exceeded',
          text: `This family already has two campaigns registered`,
          showConfirmButton: true,
          onClose: () => {
            this.newAdFamily = null;
          }
        });
        return;
      }
    },
    adTypeChanged () {
      
      this.isAdTextsChanged = true;
      /* Set the min required texts - number */
      this.resetTextsCounts();

      switch (this.adType) {
        case 'RESPONSIVE_DISPLAY_AD':
          this.isAdHeadActive = true;
          this.isAdLongHeadActive = true;
          this.isAdDescriptionActive = true;
          this.isAdImageAssetsActive = true;
          this.isAdVideoAssetsActive = true;
          this.isAdBusinessNameActive = true;
          break;

        case 'RESPONSIVE_SEARCH_AD':
          this.isAdHeadActive = true;
          this.isAdLongHeadActive = false;
          this.isAdDescriptionActive = true;
          this.isAdImageAssetsActive = false;
          this.isAdVideoAssetsActive = false;
          this.isAdBusinessNameActive = false;
          break;

        default:
          break;
      }
    },
    resetTextsCounts () {
      let headDiff = Math.abs(this.textCountLimits[this.adType].headlines.min - this.currentAdTexts.headlines.length);
      let headDiffMax = Math.abs(this.textCountLimits[this.adType].headlines.max - this.currentAdTexts.headlines.length);
      if (this.currentAdTexts.headlines.length < this.textCountLimits[this.adType].headlines.min) {
        for (let i = 1; i <= headDiff; i++) {
          this.currentAdTexts.headlines.push('');
        }
      } else if (this.currentAdTexts.headlines.length > this.textCountLimits[this.adType].headlines.max) {
        this.currentAdTexts.headlines.splice(this.currentAdTexts.headlines.length - headDiffMax, headDiffMax);
      }
      let descDiff = Math.abs(this.textCountLimits[this.adType].descriptions.min - this.currentAdTexts.descriptions.length);
      let descDiffMax = Math.abs(this.textCountLimits[this.adType].descriptions.max - this.currentAdTexts.descriptions.length);
      if (this.currentAdTexts.descriptions.length < this.textCountLimits[this.adType].descriptions.min) {
        for (let i = 1; i <= descDiff; i++) {
          this.currentAdTexts.descriptions.push('');
        }
      } else if (this.currentAdTexts.descriptions.length > this.textCountLimits[this.adType].descriptions.max) {
        this.currentAdTexts.descriptions.splice(this.currentAdTexts.descriptions.length - descDiffMax, descDiffMax);
      }
    },
    addAdText (type) {
      this.currentAdTexts[type].push('');
    },
    removeAdText (type, index) {
      this.isAdTextsChanged = true;
      this.currentAdTexts[type].splice(index, 1);
    },
    cropImage () {
      const { canvas } = this.$refs.cropper.getResult();
      this.croppedImage = canvas.toDataURL();
    },
    cropImageRestriction ({ minWidth, minHeight, maxWidth, maxHeight, imageWidth, imageHeight }) {
      return {
        minWidth: minWidth,
        minHeight: minHeight,
        maxWidth: maxWidth,
        maxHeight: maxHeight,
      };
    },
    async saveCroppedImage () {
      let blobBin = atob(this.croppedImage.split(',')[1]);
      let unicodeArray = [];
      for (let i = 0; i < blobBin.length; i++) {
          unicodeArray.push(blobBin.charCodeAt(i));
      }
      let file = new Blob([new Uint8Array(unicodeArray)], { type: 'image/jpg' });
      await this.uploadCroppedImage(file, this.croppingImageType);

    },
    openImageCrop (image, type) {
      if (image && type) {
        this.showCropImagePopup = true;
        this.croppingImage = image;
        this.croppingImageType = type;
      }
    },
    closeImageCrop () {
      this.showCropImagePopup = false;
      this.croppingImage = null;
      this.croppedImage = null;
    },
    async saveAdTexts () {
      if (this.$refs.adInfoForm.validate()) {

        let adUpdatePayload = JSON.parse(JSON.stringify(this.currentGoogleAd));
        adUpdatePayload.campaign = adUpdatePayload.campaign.id;
        adUpdatePayload.account = adUpdatePayload.account.id;
        adUpdatePayload.texts = this.currentAdTexts;
        adUpdatePayload.type = this.adType;

        let { error, data } = await update('GoogleAd', adUpdatePayload, adUpdatePayload.id);
        if (error) {
            swal.fire({
              type: 'warning',
              title: `Update Failed`,
              text: `Failed to update the ad texts, ${error}`,
              showConfirmButton: true,
              onClose: () => {}
            });
            return;
        } else if (data) {
            this.currentGoogleAd.texts = data.texts || this.currentAdTexts;
            this.currentGoogleAd.type = data.type || this.adType;
            this.isAdTextsChanged = false;
            swal.fire({
              type: 'success',
              title: 'Draft Saved',
              text: 'The ad texts were saved as draft successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {}
            });
            return;
        }
      }
    },
    async fetchGoogleAds () {
      // if (!this.GoogleAd.length) {
      let sort = { createdAt: -1 };
      let populate = [{ path: 'campaign' }, { path: 'account', select: 'name nickname' }];
      let where = { account: { $exists: true }, mode: 'Individual' };
      let { error, data } = await getCollection('GoogleAd', true, 0, populate, where, null, null, sort);
      if (error) {
          console.log(error);
      } else if (data.length > 0) {
          /* Filter only the individual ads - having campaign.account */
          this.GoogleAd = data.filter(x => x.campaign && x.campaign.account);
          this.googleAdList = JSON.parse(JSON.stringify(this.GoogleAd));
          this.filterByStatus();
      }
      // }
    },
    deleteItem (item) {

      swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
          /* if (result.value) {
          (async () => {
              let { error, data, status } = await remove('Country', item.id);
              if (error) {
              console.log('error', error);
              } else {
              const index = this.Country.indexOf(item);
              this.Country.splice(index, 1);
              swal.fire(
                  'Deleted!',
                  'The Country "' + item.name + '" has been deleted.',
                  'success'
              );
              }
          })();
          } */
      });
    },
    async publishCampaign () {
      if (this.$refs.adInfoForm.validate()) {
        let error = null;
        let index = this.GoogleAd.findIndex(x => x.id === this.currentGoogleAd.id);
        let campaignData = null;
  
        if (!this.currentGoogleAd.campaign.resource) {
          let campaignPayload = {
              campaign: this.currentGoogleAd.campaign.id,
              type: this.adType === 'RESPONSIVE_DISPLAY_AD' ? 'DISPLAY' : 'SEARCH'
          };
          let { error: campaignError, data } = await request('Campaign/Create', 'POST', campaignPayload);
          error = campaignError;
          campaignData = data;
        } else {
          campaignData = this.currentGoogleAd.campaign;
        }

        if (error) {
            console.log(error);
            swal.fire({
              type: 'warning',
              title: error.message,
              text: `${typeof error === 'string' ? error : error.details ? error.details[0].errors[0].message : error.message}, please contact your agency`,
              showConfirmButton: true,
              onClose: () => {
                this.resetSelections();
              }
            });
        } else {
          if (!campaignData) {
            swal.fire({
              type: 'warning',
              title: 'Error',
              text: `Something went wrong, please contact your agency`,
              showConfirmButton: true,
              onClose: () => {
                // 
              }
            });
          } else {
            /* Set the campaign resource if newly created */
            if (!this.currentGoogleAd.campaign.resource) {
              this.GoogleAd[index].campaign.resource = campaignData.resource;
              this.GoogleAd[index].campaign.status = campaignData.status;
            }
            this.googleAdList = JSON.parse(JSON.stringify(this.GoogleAd));
    
            if (!this.currentGoogleAd.resource) {
    
              /* Create the Google Ad - if not already created */
              let adPayload = {
                  google_ad: this.currentGoogleAd.id,
                  assets: this.currentAssets,
                  additional_info: this.currentAdTexts,
                  ad_type: this.adType
              };
              let { error: adError, data: adData } = await request('GoogleAd/Create', 'POST', adPayload);
              if (adError) {
                  console.log(adError);
                  swal.fire({
                    type: 'warning',
                    title: adError.message,
                    text: `${adError.details[0].errors[0].message}, please contact your agency`,
                    showConfirmButton: true,
                    onClose: () => {
                      this.resetSelections();
                    }
                  });
              } else {
                  /* Set the ad resource */
                  this.GoogleAd[index].resource = adData.resource;
                  this.GoogleAd[index].status = adData.status;
                  this.GoogleAd[index].texts = adData.texts;
                  this.googleAdList = JSON.parse(JSON.stringify(this.GoogleAd));

                  /* Create the timeline */
                  let timelineData = {
                    title: 'Published Campaign',
                    text: `The Google campaign was published`,
                    account: this.currentGoogleAd.account.id,
                    type: 'campaignPublished'
                  };
                  let { error, data, status } = await create('Timeline', timelineData);
                  // eslint-disable-next-line
                  if (error) {
                    console.log('error', error);
                    this.snackbar = {
                      show: true,
                      color: 'orange',
                      text: 'Failed to create the timeline'
                    };
                  }

                  swal.fire({
                      type: 'success',
                      title: 'Campaign created',
                      text: 'Your campaign was created successfully',
                      showConfirmButton: false,
                      timer: 2500,
                      onClose: () => {
                          this.resetSelections();
                          this.filterByStatus();
                      }
                  });
              }
            } else {
              swal.fire({
                  type: 'success',
                  title: 'Campaign created',
                  text: 'Your campaign was created',
                  showConfirmButton: false,
                  timer: 2500,
                  onClose: () => {
                      this.resetSelections();
                  }
              });
            }
          }
        }
      }
    },
    async publishDirectCampaign () {
      if (this.$refs.newAdInfoForm.validate()) {
        let error = null;
  
        let campaignPayload = {
            account: this.newAdFamily,
            budget: this.newCampaignBudget,
            campaign_type: this.adType === 'RESPONSIVE_DISPLAY_AD' ? 'DISPLAY' : 'SEARCH',
            assets: this.currentAssets,
            asset_ids: this.newAdAssetIds, // To update the ad id after create
            additional_info: this.currentAdTexts,
            ad_type: this.adType
        };
        let { error: campaignError, data } = await request('Campaign/Direct/Create', 'POST', campaignPayload);
        error = campaignError;

        if (error) {
            console.log(error);
            swal.fire({
              type: 'warning',
              title: error.message || 'Warning',
              text: `${error.details ? error.details[0].errors[0].message : (error.message || error)}`,
              showConfirmButton: true,
              onClose: () => {
                this.resetSelections();
              }
            });
        } else {
  
          /* Create the timeline */
          let timelineData = {
            title: 'Published Campaign',
            text: `The Google campaign was published`,
            account: this.newAdFamily,
            type: 'campaignPublished'
          };
          let { error, data, status } = await create('Timeline', timelineData);
          // eslint-disable-next-line
          if (error) {
            console.log('error', error);
            this.snackbar = {
              show: true,
              color: 'orange',
              text: 'Failed to create the timeline'
            };
          }

          /* Fetch the init data again */
          await this.init();

          swal.fire({
              type: 'success',
              title: 'Campaign created',
              text: 'New campaign was created successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                  this.resetSelections();
                  this.filterByStatus();
              }
          });
        }
      }
    },
    async adAdditionalInfo (item) {
      this.currentGoogleAd = item;

      /* Populate the ad texts */
      if (this.currentGoogleAd.texts && Object.keys(this.currentGoogleAd.texts).length) {
        this.currentAdTexts = this.currentGoogleAd.texts;
      }
      /* Reset the ad type if exists */
      if (this.currentGoogleAd.type) {
        this.adType = this.currentGoogleAd.type;
        this.adTypeChanged();
      }
      /* Reset the text counts */
      this.resetTextsCounts();

      /* Fetch the ad assets */
      let where = { account: this.currentGoogleAd.account.id, google_ad: this.currentGoogleAd.id };
      let { error, data } = await getCollection('GoogleAdAsset', true, 0, '', where);
      if (error) {
        console.log(error);
      } else if (data && data.length) {
        /* Check if the asset is landscape or square */
        for (let i = 0; i < data.length; i++) {
          this.currentAssets[data[i].image_type] = data[i].resource;
        }
      }
      this.showAddDetailsPopup = true;
    },
    editAdTexts (item) {
      this.currentGoogleAd = item;
      this.adType = this.currentGoogleAd.type || 'RESPONSIVE_DISPLAY_AD';

      /* Populate the ad texts */
      if (this.currentGoogleAd.texts && Object.keys(this.currentGoogleAd.texts).length) {
        this.currentAdTexts = this.currentGoogleAd.texts;
      }
      /* Trigger the ad type change */
      this.adTypeChanged();

      this.showEditTextsPopup = true;
    },
    async publishAdTexts () {
      if (this.$refs.adTextsUpdateForm.validate()) {
        let index = this.GoogleAd.findIndex(x => x.id === this.currentGoogleAd.id);
  
        let adTextsPayload = {
            texts: this.currentAdTexts
        };
        let { error, data } = await request(`GoogleAd/Texts/${this.currentGoogleAd.id}`, 'PUT', adTextsPayload);

        if (error) {
            swal.fire({
              type: 'warning',
              title: 'Error',
              text: `${error.message || error}, please try again`,
              showConfirmButton: true,
              onClose: () => {
                this.resetSelections();
              }
            });
        } else {
          /* Set the ad texts in state */
          this.GoogleAd[index].texts = data.texts || this.currentAdTexts;
          this.currentGoogleAd.texts = data.texts || this.currentAdTexts;
          this.googleAdList = JSON.parse(JSON.stringify(this.GoogleAd));
  
          swal.fire({
              type: 'success',
              title: 'Ad updated',
              text: 'The Google ad texts were updated successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                  this.resetSelections();
              }
          });
        }
      }
    },
    resetSelections (isUpdate = false) {

      this.isAdHeadActive = this.isAdLongHeadActive = this.isAdDescriptionActive = this.isAdImageAssetsActive = this.isAdVideoAssetsActive = this.isAdBusinessNameActive = true;

      this.showAddDetailsPopup = false;
      this.showEditTextsPopup = false;

      this.showAddCampaignPopup = false;
      this.isNewAdFamilySelected = false;
      this.newAdFamily = null;
      this.newCampaignBudget = 0;
      this.remainingBudget = 0;

      if (isUpdate) {
        this.currentAdTexts = this.currentGoogleAd.texts;
      } else {
        this.currentAdTexts = {
          headlines: [''],
          descriptions: [''],
          long_headline: '',
          business_name: 'ParentFinder BM Campaign',
        };
      }
      this.currentGoogleAd = null;
      this.currentAssets = {
        landscape: null,
        square: null,
        youtubeVideo: {
          title: '',
          videoId: ''
        }
      };
      /* Reset the list */
      this.googleAdList = JSON.parse(JSON.stringify(this.GoogleAd));
      this.filterByStatus();
    },
    async fileSelected (file, type) {
      let self = this;
      if (file) {
        if (file.name.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener('load', async (image) => {
          let img = new Image();
          img.src = image.target.result;
          img.addEventListener('load', async (fileLoad) => {
            if (fileLoad.path[0].width < self.assetResolution[type].width || fileLoad.path[0].height < self.assetResolution[type].height) {
              swal.fire({
                type: 'warning',
                title: 'Invalid Resolution',
                text: `The ${type} image should have a minimum resolution of ${self.assetResolution[type].width} x ${self.assetResolution[type].height}`,
                showConfirmButton: true,
                onClose: () => {
                  window.getApp.$emit('AppProgress', false);
                  return;
                }
              });
              this.$refs[type].clear();
              return;

            } else {
              /* Crop the image */
              this.openImageCrop(img.src, type);
            }
          });
        });
      }
    },

    async uploadCroppedImage (file, type) {
      let self = this;
      if (file && (this.currentGoogleAd || this.newAdFamily)) {
        const fr = new FileReader();
        fr.readAsDataURL(file);
        fr.addEventListener('load', async (image) => {
          let img = new Image();
          img.src = image.target.result;
          img.addEventListener('load', async (fileLoad) => {
            
            if (fileLoad.path[0].width >= self.assetResolution[type].width || fileLoad.path[0].height >= self.assetResolution[type].height) {
              
              window.getApp.$emit('AppProgress', true);
              let postUrl = 'GoogleAdAsset/UploadAsset';
              let extraParams = {
                account: this.currentGoogleAd ? this.currentGoogleAd.account.id : this.newAdFamily,
                image_type: type
              };
              if (this.currentGoogleAd) {
                extraParams.google_ad = this.currentGoogleAd.id;
              }
              let response = await uploadFile(postUrl, file, 'POST', extraParams);
              if (response.$error) {
                
                if (response.$error.details) {
                  swal.fire({
                    type: 'warning',
                    title: response.$error.message,
                    text: `${response.$error.details[0].errors[0].message}`,
                    showConfirmButton: true,
                    onClose: () => {
                      // 
                    }
                  });
                } else {
                  swal.fire({
                    type: 'warning',
                    title: 'Error',
                    text: `${response.$error}`,
                    showConfirmButton: true,
                    onClose: () => {
                      // 
                    }
                  });
                }
                return;

              } else {
                if (response.$data) {
                  this.currentAssets[type] = response.$data.resource;
                  this.newAdAssetIds[type] = response.$data.id;
                }
                swal.fire({
                  type: 'success',
                  title: 'Image uploaded successfully',
                  showConfirmButton: false,
                  timer: 2500,
                  onClose: () => {
                    window.getApp.$emit('AppProgress', false);
                    this.closeImageCrop();
                  }
                });
              }

            } else {
              swal.fire({
                type: 'warning',
                title: 'Invalid Resolution',
                text: `The ${type} image should have a minimum resolution of ${self.assetResolution[type].width} x ${self.assetResolution[type].height}`,
                showConfirmButton: true,
                onClose: () => {
                  window.getApp.$emit('AppProgress', false);
                  return;
                }
              });
              return;
            }
            this.$refs[type].clear();
          });
        });
      }
    },
  }
};
</script>
<style scoped>
.upload-btn {
  padding: 0 !important;
  margin-left: -10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Campaign/admin_main.vue